<template>
<a href="#" :class="current" :data-scp="scp" @click.prevent.stop="toggle">
	<i class="icon icon-more" style="font-size: 24px;"></i><span>显示菜单</span>
</a>
</template>
<script>
export default {
	props: ['current', 'scp']
	, methods: {
		toggle: function(){
			this.$dispatch('toggleMenu');
		}
	}
};
</script>